export class BrandColour {

    constructor (
        public name: string, // "primary-dark",
        public hex: string, // "#FF00FF",
    ){
        this.name = name;
        this.hex = hex;
    }
}